let mobileOpen = $('.mobile-menu-toggle'),
    mobileClose = $('#site-navigation-close'),
    mobileMenu = $('#primary-navigation'),
    menuItemsWithChildren = $('.menu-item-has-children');

// Helper function to check if we're on mobile
function isMobile() {
    return $(window).width() < 992;
}

// Open a submenu and move focus to first item
function openSubMenu($menuItem) {
    let $submenu = $menuItem.find('.sub-menu').first();

    $menuItem.addClass('is-open');

    if (isMobile()) {
        $submenu.slideDown();
    } else {
        $submenu.show();
    }

    // Move focus to first link in submenu
    let $firstLink = $submenu.find('a').first();
    if ($firstLink.length) {
        $firstLink.focus();
    }
}

// Close a submenu and optionally return focus
function closeSubMenu($menuItem, returnFocus = true) {
    let $submenu = $menuItem.find('.sub-menu').first();
    let $parentLink = $menuItem.find('> a').first();

    $menuItem.removeClass('is-open');

    if (isMobile()) {
        $submenu.slideUp();
    } else {
        $submenu.hide();
    }

    // Return focus to parent link
    if (returnFocus && $parentLink.length) {
        $parentLink.focus();
    }
}

// Toggle a submenu
function toggleSubMenu($menuItem) {
    if ($menuItem.hasClass('is-open')) {
        closeSubMenu($menuItem, false);
    } else {
        openSubMenu($menuItem);
    }
}

// Mobile menu open/close
mobileOpen.on('click', function() {
    $(this).addClass('is-open');
    mobileMenu.fadeIn();
});

mobileClose.on('click', function() {
    mobileOpen.removeClass('is-open');
    mobileMenu.fadeOut();
});

// Handle clicks on menu items with children
menuItemsWithChildren.find('> a').on('click', function(e) {
    if (isMobile()) {
        e.preventDefault();
        toggleSubMenu($(this).parent());
    }
});

// Handle keyboard navigation
menuItemsWithChildren.find('> a').on('keydown', function(e) {
    let $menuItem = $(this).parent();

    // Enter key - toggle submenu
    if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        toggleSubMenu($menuItem);
    }
});

// Handle Escape key to close submenus
$(document).on('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        // Find any open submenus
        let $openMenuItems = $('.menu-item-has-children.is-open');

        if ($openMenuItems.length) {
            // Check if focus is within a submenu
            let $focusedElement = $(document.activeElement);
            let $parentMenuItem = $focusedElement.closest('.menu-item-has-children.is-open');

            if ($parentMenuItem.length) {
                // Close the submenu that contains the focused element
                closeSubMenu($parentMenuItem, true);
            } else {
                // Close all open submenus if focus is elsewhere
                $openMenuItems.each(function() {
                    closeSubMenu($(this), false);
                });
            }
        }
    }
});

// Close submenus on desktop when clicking outside
$(document).on('click', function(e) {
    if (!isMobile()) {
        if (!$(e.target).closest('.menu-item-has-children').length) {
            $('.menu-item-has-children.is-open').each(function() {
                closeSubMenu($(this), false);
            });
        }
    }
});

// look for all links with url that starts with /schedule-an-appointment/ and append ?location-source= + location name to the url
if(typeof window.locations_page_data !== 'undefined' && window.locations_page_data) {
    $('a').each(function () {
        let href = $(this).attr('href');

        if (href && href.startsWith(window.location.origin)) {
            href = href.replace(window.location.origin, '');
        }

        if (href && href.startsWith('/schedule-an-appointment/')) {
            let locationName = window.locations_page_data.slug;
            let url = $(this).attr('href');
            url += '?location-source=' + encodeURIComponent(locationName);
            $(this).attr('href', url);
        }
    });
}
